import { AUTH_TOKEN } from "constants/AuthConstant";
import fetch from "auth/FetchInterceptor";

const BlogService = {};

BlogService.getAllBlogs = function (searchValue = "", page = 1) {
  let url = `/blog/?page=${page}`;
  
  if (searchValue) {
    url += `&search=${encodeURIComponent(searchValue)}`;
  }

  return fetch({
    method: "get",
    url: url,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });
};
BlogService.getBlogById = function (id) {
  return fetch({
    method: "get",
    url: `/blog/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });
};

BlogService.createBlog = function (data) {
  return fetch({
    method: "post",
    url: `/blog/`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      // If you are uploading a cover image, you might need multipart/form-data here too
      "Content-Type": "multipart/form-data", 
    },
  });
};

BlogService.updateBlogById = function (id, data) {
  return fetch({
    method: "put",
    url: `/blog/${id}`,
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

BlogService.deleteBlogById = function (id) {
  return fetch({
    method: "delete",
    url: `/blog/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });
};

export default BlogService;